<script lang="ts" setup>
import { computed } from 'vue'
import type { ImgHTMLAttributes } from 'vue'

const props = withDefaults(
  defineProps<{
    src: string
    alt?: string
    width?: number
    height?: number
    imgAttrs?: Omit<ImgHTMLAttributes, 'id'>
    sizes?: string // format: lg:400px md:500px sm:600px / lg:500w md:500h sm:500h xs:500w
  }>(),
  {
    src: '',
    alt: '',
  },
)

/* Sizes breakpoint */
const screens: { [key: string]: number } = {
  xs: 0,
  sm: 568,
  md: 768,
  lg: 992,
  xl: 1024,
  xxl: 1140,
}

const getSizes = computed(() => {
  const finalSizes: { url: string; breakpoint: number }[] = []
  const unitRegex = /h|w/
  const formatSizes = props.sizes?.split(' ') // string to array sizes

  formatSizes?.map((size) => {
    const formatted = size.split(':') // split breakpoint from width => [breakpoint]: width
    const breakpoint = formatted[0]
    const sizeNumber = Number(formatted[1].replace(unitRegex, '')) // Number for the image size
    const sizeOrientation = formatted[1].match(unitRegex) // Width or Height ?

    /** Based on sizes => calculate resize if width or height size */
    const finalResize =
      sizeOrientation?.[0] === 'h'
        ? resizer(props.src, undefined, sizeNumber)
        : resizer(props.src, sizeNumber)

    // create array with all the sources based on sizes string props
    finalSizes.push({
      url: finalResize, // get resized image url
      breakpoint: screens[breakpoint], // get breakpoint
    })
  })
  return finalSizes
})

const resizeImage = computed(() => {
  return resizer(props.src, props.width, props.height)
})

const resizer = (src: string, width?: number | undefined, height?: number | undefined) => {
  return window.GalaxyHelpers.resizeImg(src, width, height)
}

// placeholder ? / preset="cover" ?: can be used create unified form of images / fit="cover"
// add lazyloading
</script>
<template>
  <picture>
    <source
      v-for="(el, index) in getSizes"
      :key="index"
      :srcset="el.url"
      :media="`(min-width: ${el.breakpoint}px)`"
    />
    <img
      :src="resizeImage"
      :alt="alt"
      :width="width"
      :height="height"
      v-bind="imgAttrs"
      loading="lazy"
    />
  </picture>
</template>
